import { render, staticRenderFns } from "./LmsBasicTemplate.vue?vue&type=template&id=15686761&scoped=true"
import script from "./LmsBasicTemplate.vue?vue&type=script&lang=js"
export * from "./LmsBasicTemplate.vue?vue&type=script&lang=js"
import style0 from "./LmsBasicTemplate.vue?vue&type=style&index=0&id=15686761&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15686761",
  null
  
)

export default component.exports